import React, { useContext } from 'react';
import { Context } from 'components/Store';
import PropTypes from 'prop-types';
import Breadcrumb from 'components/App/AppShell/components/Breadcrumb';
import PropertyLandingContext from 'screens/Property/PropertiesLanding/context';
import usePropertyFilters from 'hooks/usePropertyFilters';

const PropertyBreadcrumb = ({
  disabledOrgChange = false,
  disabledPropertyChange = false
}) => {
  const [context] = useContext(Context);
  const { selectedProperty } = context;
  const {
    isLoadingProperties,
    setParams,
    onPropertySelection,
    isFarmSelected,
    isFieldSelected,
    isHugeOrganization,
    guardNavigation,
    isFormDirty,
    resetPropertyFiltersForOrganizationChange
  } = useContext(PropertyLandingContext);
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  const { filteredProperties } = usePropertyFilters(
    undefined,
    isHugeOrganization
  );

  const getBreadcrumbTitle = () => {
    if (isEnableInfoTabEdit) {
      if (isFarmSelected) {
        return 'Edit Farm';
      }
      if (isFieldSelected) {
        return `Edit Field info: ${selectedProperty?.name}`;
      }
    }
    if (!selectedProperty?.id) {
      return 'All Properties';
    }
    if (isFarmSelected) {
      return selectedProperty?.name;
    }
    return (
      filteredProperties.find(farm => farm.id === selectedProperty.farmId)
        ?.name || selectedProperty?.name
    );
  };

  const title = getBreadcrumbTitle();

  const handleOrganizationSelect = org => {
    onPropertySelection();
    setParams({ page: 0, orgId: org?.id });
  };

  const handleOrganizationConfirm = (org, selectFunction) => {
    guardNavigation(async () => {
      await selectFunction();
      resetPropertyFiltersForOrganizationChange();
    });
  };

  // Creating a new crop season/org otherwise lets the user fill out and
  // submit the whole create form before the guard ever runs, so by the time
  // it shows up the season/org already exists in the backend. Gating the
  // create form's own open blocks that earlier, the same way selecting an
  // existing season/org is blocked before it switches anything.
  //
  // Only routed through guardNavigation when the form is actually dirty:
  // guardNavigation's clean-form branch also exits edit mode, which is right
  // for a real navigation but not for merely opening a dialog the user might
  // immediately cancel without ever leaving the current crop zone. Shared by
  // both the season and organization create flows, which gate identically.
  const handleCreateConfirm = openCreateModal => {
    if (isFormDirty) {
      guardNavigation(openCreateModal);
    } else {
      openCreateModal();
    }
  };

  return (
    <Breadcrumb
      onOrganizationSelect={handleOrganizationSelect}
      onOrganizationConfirm={handleOrganizationConfirm}
      onOrganizationCreateConfirm={handleCreateConfirm}
      disabled={disabledOrgChange}
      disabledCropSeasons={isLoadingProperties}
      hideCropSeasonDropdown={false}
      onCropSeasonSelect={handleOrganizationSelect}
      onCropSeasonCreateConfirm={handleCreateConfirm}
    >
      {disabledPropertyChange && (
        <Breadcrumb.Item title="Properties" value={title} isLast />
      )}
      {!disabledPropertyChange && title && (
        <Breadcrumb.Item title="Properties" value={title} />
      )}
    </Breadcrumb>
  );
};

PropertyBreadcrumb.propTypes = {
  disabledOrgChange: PropTypes.bool,
  disabledPropertyChange: PropTypes.bool
};

export default PropertyBreadcrumb;
